/**
 * molto-conditionnement (lot 2.3, C1) - affiche sous le prix :
 *   "Prix par carton de N unités (X paquets de Y)"  puis  "3 cartons = 300 unités" (mis à jour avec la quantité).
 *
 * Règles :
 *  - données = métachamps existants (lus en Liquid par le snippet molto-conditionnement, jamais écrits) ;
 *  - on n'affiche RIEN plutôt qu'une valeur douteuse (voir `lire`) ;
 *  - ne modifie, ne lit et ne déplace JAMAIS le bloc Massy (massy-app-root, <massy-custom-pricing>,
 *    <massy-volume-discount>, massy-tier-highlight.js) : cet élément vit à côté, dans son propre bloc ;
 *  - compatible avec l'injection tardive de Massy (1,7 à 3,3 s) : aucune dépendance au DOM Massy.
 */
(function () {
  'use strict';
  if (customElements.get('molto-conditionnement')) return;

  var SEP_MILLIERS = /[\s  ]/g;

  /** Tous les nombres d'un texte ("· Soit 10 000 Unités par Carton" -> [10000]). */
  function nombres(texte) {
    var m = String(texte || '').match(/\d[\d\s  ]*/g) || [];
    return m.map(function (x) { return parseInt(x.replace(/\D/g, ''), 10); }).filter(function (n) { return isFinite(n); });
  }

  /** Le nombre du texte s'il y en a exactement un, sinon null. */
  function unique(texte) {
    var n = nombres(texte);
    return n.length === 1 && n[0] > 0 ? n[0] : null;
  }

  function fmt(n) { return n.toLocaleString('fr-FR'); }
  function pluriel(n, s, p) { return n > 1 ? p : s; }

  /**
   * Retourne { unites, paquets, unitesPaquet } ou null.
   * Contrôles : un seul nombre par champ ; si le titre porte "(N unités)" il doit être égal à N ;
   * N doit être corroboré (par le titre, ou par paquets x unités par paquet).
   * "(X paquets de Y)" n'est affiché que si X x Y = N (sinon une des trois valeurs est fausse).
   */
  function lire(el) {
    var n = unique(el.dataset.carton);
    if (!n) return null;
    var x = unique(el.dataset.paquets);
    var y = unique(el.dataset.unitesPaquet);
    var t = /\((\d[\d\s  ]*)\s*unit/i.exec(el.dataset.titre || '');
    var titre = t ? parseInt(t[1].replace(SEP_MILLIERS, ''), 10) : null;
    if (titre !== null && titre !== n) return null;            // le titre contredit le métachamp : on se tait
    var coherent = !!(x && y && x * y === n);
    if (titre === null && !coherent) return null;              // aucune corroboration : on se tait
    return { unites: n, paquets: coherent ? x : null, unitesPaquet: coherent ? y : null };
  }

  class MoltoConditionnement extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.donnees = lire(this);
      if (!this.donnees) { this.hidden = true; return; }
      var d = this.donnees;
      var ligne = this.querySelector('[data-ligne]');
      var texte = 'Prix par carton de ' + fmt(d.unites) + ' ' + pluriel(d.unites, 'unité', 'unités');
      if (d.paquets) texte += ' (' + fmt(d.paquets) + ' ' + pluriel(d.paquets, 'paquet', 'paquets') + ' de ' + fmt(d.unitesPaquet) + ')';
      if (ligne) ligne.textContent = texte;
      this.hidden = false;
      this._surveiller();
    }

    disconnectedCallback() {
      if (this._timer) clearInterval(this._timer);
      if (this._onEvent) {
        document.removeEventListener('input', this._onEvent, true);
        document.removeEventListener('change', this._onEvent, true);
        document.removeEventListener('click', this._onClick, true);
      }
    }

    _champQuantite() {
      var scope = this.closest('product-information, main, form') || document;
      return scope.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    }

    _maj() {
      var out = this.querySelector('[data-volume]');
      var champ = this._champQuantite();
      if (!out || !champ) return;
      var brut = String(champ.value || '').trim();
      var q = /^\d{1,7}$/.test(brut) ? parseInt(brut, 10) : NaN;
      var vide = !(q >= 1);
      var texte = vide ? '' : fmt(q) + ' ' + pluriel(q, 'carton', 'cartons') + ' = ' + fmt(q * this.donnees.unites) + ' ' + pluriel(q * this.donnees.unites, 'unité', 'unités');
      if (out.textContent !== texte) out.textContent = texte;
      this._derniere = brut;
    }

    _surveiller() {
      var self = this;
      this._onEvent = function (e) {
        if (e.target && e.target.matches && e.target.matches('input[name="quantity"]')) self._maj();
      };
      this._onClick = function (e) {
        if (e.target && e.target.closest && e.target.closest('quantity-selector-component')) {
          setTimeout(function () { self._maj(); }, 60);
          setTimeout(function () { self._maj(); }, 300);
        }
      };
      document.addEventListener('input', this._onEvent, true);
      document.addEventListener('change', this._onEvent, true);
      document.addEventListener('click', this._onClick, true);
      // filet de sécurité : valeur modifiée par script sans évènement
      this._timer = setInterval(function () {
        var c = self._champQuantite();
        if (c && String(c.value) !== self._derniere) self._maj();
      }, 400);
      this._maj();
    }
  }

  customElements.define('molto-conditionnement', MoltoConditionnement);
})();
